module.exports = __webpack_public_path__ + "img/user-profile-circle.1.e511e187.svg";